import React, { useState, useEffect } from "react";
import "./booking.css";
import { Form, FormGroup, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";

const Booking = () => {
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({
    userId: "01",
    useremail: "",
    fullname: "",
    phone: "",
    guestSize: 0,
    bookAt: "",
    selectedPackage: "",
    itineraryName: "", // Added a new field for itineraryName
    currentDate: "",// Added a new field for the current date
    carService: "",
  });

  useEffect(() => {
    // Extract itinerary name from the current URL (modify as needed)
    const url = window.location.pathname;
    const parts = url.split("/");
    const itineraryName = parts[parts.length - 1]; // Assuming the last part is the itinerary name

    // Set the current itinerary name and date
    const currentDate = new Date().toISOString().split("T")[0];
    setCredentials((prev) => ({ ...prev, itineraryName, currentDate }));
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;

    if (id === "bookAt") {
      // Check if the selected date is not a past date
      if (value < credentials.currentDate) {
        return;
      }
    } else if (id === "guestSize") {
      // Check if the entered guest size is not negative
      const guestSize = parseInt(value);
      if (isNaN(guestSize) || guestSize < 0) {
        return;
      }
    }

    setCredentials((prev) => ({ ...prev, [id]: value }));
  };

  const handleClick = (e) => {
    e.preventDefault();

    emailjs.init("5jHtz5YTo4yK5yAXW");

    const templateParams = {
      from_name: credentials.fullname,
      useremail: credentials.useremail,
      guest_size: credentials.guestSize,
      phone: credentials.phone,
      book_at: credentials.bookAt,
      selected_package: credentials.selectedPackage,
      itinerary_name: credentials.itineraryName, // Pass the itinerary name to the email template
      car_service: credentials.carService, // Add the car service field
    };

    emailjs.send("service_m6apr1s", "template_etuhmn7", templateParams).then(
      function (response) {
        console.log("Email sent successfully:", response);
        navigate("/thank-you");
      },
      function (error) {
        console.log("Email sending failed:", error);
      }
    );
  };

  return (
    <div className="booking">
      <div className="booking__form">
        <h5>For More Information</h5>
        <Form className="booking__info-form" onSubmit={handleClick}>
          <FormGroup>
            <input
              type="text"
              placeholder="Full Name"
              id="fullname"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <input
              type="email"
              placeholder="Email"
              id="useremail"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup>
            <input
              type="tel"
              placeholder="Phone"
              id="phone"
              required
              onChange={handleChange}
            />
          </FormGroup>
          <FormGroup className="d-flex align-items-center gap-3">
            <input
              type="date"
              placeholder=""
              id="bookAt"
              min={credentials.currentDate}
              required
              onChange={handleChange}
            />
            <input
              type="number"
              placeholder="Guest"
              id="guestSize"
              required
              onChange={handleChange}
              defaultValue="0"
              min="0"
            />
          </FormGroup>
          <FormGroup>
            <select
              id="selectedPackage"
              value={credentials.selectedPackage}
              onChange={handleChange}
              defaultValue="" // Set default value to the empty string
            >
              <option value="" disabled hidden>
                Select Hotel Type
              </option>
              <option value="3-star hotel">3-star hotel</option>
              <option value="4-star hotel">4-star hotel</option>
              <option value="5-star hotel">5-star hotel</option>
            </select>
          </FormGroup>
          <FormGroup>
            <select
              id="carService"
              value={credentials.carService}
              onChange={handleChange}
              defaultValue=""
            >
              <option value="" disabled hidden>
                Car Rental Plan
              </option>
              <option value="Luxury">Luxury</option>
              <option value="Economy">Economy</option>
              <option value="Premium">Premium</option>
            </select>
          </FormGroup>

          <FormGroup>
            <input
              type="hidden"
              id="itineraryName"
              value={credentials.itineraryName}
            />
          </FormGroup>
          <Button className="btn primary__btn w-100 mt-4" type="submit">
            Inquire Now
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Booking;
